/* rb-fitnote.js — a plain-spoken "how this length will fit" line on the
   denim size picker. Rev 2, 29 Sep 2026.

   Mark picked layout B (one sentence) and the RELAXED wording: one height
   anchor instead of ranges, and no sold-out talk.

     before a waist:  "Wear a Medium in shorts? Start with a 32 waist here."
     after a waist:   "Most guys around 5'10" wear a 32 inseam.
                       Shorter? Try a 30. Taller? Try a 34."
                      (rev 4: "inseam" to match the button label, "Try"
                      over "Go" so it suggests rather than tells)
     one inseam only: "One inseam here, the 32. Right for most guys around
                       5'10"."

   Mark's rules for the short/tall lines:
     - Shorter: offer the 30 only when it's in stock for that waist.
       Otherwise nothing ("roll the cuff" was cut: Mark found it demanding).
     - Taller: guys over about 6'2" are rare, so offer the 34 only when it's
       in stock, and say nothing otherwise.

   NOTHING TO FILL IN (Mark: input is too much choice). It reads only what
   the page already shows.

   WHERE IT RUNS (phone and desktop):
     1. Product page. rb-m-pdp.js draws the waist → inseam picker
        (.rbm-denim) and redraws it on every tap; rb-d-pdp.js reuses it on
        desktop. The line goes under it.
     2. Phone quick-add sheet on collections. rb-m-qa.js puts waist chips
        (.rbm-qsw) over the theme's size rows. The line goes between the
        waist chips and the "Inseam" label.
   Neither the theme's radios nor its rows are touched, so price, stock,
   Add and Notify behave as before.

   Heights come from inseam-audit/README.md: 32 is about 5'8"–6'0" (Jeans.com,
   Levi's-style guides, ANSUR II), so the anchor is "around 5'10"".
   Letter → waist comes from the brand's own chart where the theme has one,
   else S 30 · M 32 · L 34 · XL 38. */
(function () {
  'use strict';

  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('rbm-fitnote') || {}).textContent || '{}'); } catch (e) {}

  var ANCHOR = { 30: '5’7”', 32: '5’10”', 34: '6’1”', 36: '6’3”' };
  var BRAND_M = { 'ag jeans': 32, 'citizens of humanity': 32, 'mavi': 32, 'roark': 31 };
  function mediumWaist() {
    var v = BRAND_M[(cfg.vendor || '').toLowerCase()];
    return v || 32;
  }

  /* rows: [{w, l, ok}] for every NNxNN size; w = the chosen waist or '' */
  function sentence(rows, w) {
    var lengths = [];
    rows.forEach(function (r) { if (lengths.indexOf(r.l) < 0) lengths.push(r.l); });
    lengths.sort(function (a, b) { return a - b; });

    if (lengths.length === 1) {
      var only = lengths[0];
      var who = ANCHOR[+only] ? 'most guys around ' + ANCHOR[+only] : 'most guys';
      return 'One inseam here, the ' + only + '. Right for ' + who + '.';
    }
    if (!w) return 'Wear a Medium in shorts? Start with a ' + mediumWaist() + ' waist here.';

    var mine = rows.filter(function (r) { return r.w === w; });
    var has = function (l) { return mine.some(function (r) { return +r.l === l; }); };
    var inStock = function (l) { return mine.some(function (r) { return +r.l === l && r.ok; }); };
    var out = [];
    if (has(32) || !mine.length) out.push('Most guys around 5’10” wear a 32 inseam.');
    else out.push('Most guys around 5’10” wear a 32 inseam; this waist comes in ' +
      mine.map(function (r) { return r.l; }).sort(function (a, b) { return a - b; }).join(' and ') + '.');
    if (has(32)) {
      if (inStock(30)) out.push('Shorter? Try a 30.');
      if (inStock(34)) out.push('Taller? Try a 34.');
    }
    return out.join(' ');
  }

  function put(after, text, extraClass) {
    var host = after.parentNode;
    if (!host) return;
    var n = host.querySelector(':scope > .rbf-note');
    if (!text) { if (n) n.remove(); return; }
    if (!n) {
      n = document.createElement('p');
      n.className = 'rbf-note' + (extraClass ? ' ' + extraClass : '');
      host.insertBefore(n, after.nextSibling);
    } else if (n.previousElementSibling !== after) {
      host.insertBefore(n, after.nextSibling);
    }
    if (n.textContent !== text) n.textContent = text;
  }

  function split(v) {
    var m = String(v || '').trim().match(/^(\d{2})\s*x\s*(\d{2})$/i);
    return m ? { w: m[1], l: m[2] } : null;
  }

  /* ---------- 1. product page ---------- */
  function pdp() {
    var box = document.querySelector('.rbm-denim');
    if (!box) return false;
    var fs = box.parentNode;
    function paint() {
      var b = fs.querySelector('.rbm-denim');
      if (!b) return;
      var rows = [];
      fs.querySelectorAll('.product-form__swatch__item--button').forEach(function (it) {
        var s = split(it.getAttribute('data-value'));
        if (!s) return;
        var input = it.querySelector('input'), label = it.querySelector('label');
        s.ok = !(input && input.disabled) && !(label && label.classList.contains('is-disabled'));
        rows.push(s);
      });
      put(b, sentence(rows, b.dataset.w || ''));
    }
    paint();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(paint, 30); })
      .observe(fs, { childList: true, subtree: true });
    return true;
  }

  /* ---------- 2. phone quick-add sheet ---------- */
  function sheet() {
    var root = document.querySelector('.rb-qas');
    if (!root) return false;
    function paint() {
      var chips = root.querySelector('.rbm-qsw');
      var list = root.querySelector('.js-rb-qas-list');
      if (!chips || !list || !list.classList.contains('rbm-qsw-on')) {
        var old = root.querySelector('.rbf-note'); if (old) old.remove();
        return;
      }
      var rows = [];
      list.querySelectorAll('.rb-qas__row').forEach(function (r) {
        var s = split((r.querySelector('.rb-qas__row-size') || {}).textContent);
        if (!s) return;
        s.ok = !r.classList.contains('rb-qas__row--out');
        rows.push(s);
      });
      // Inside the chip box, just above its "Inseam" label, so it reads
      // Waist → the line → Inseam → the rows. rb-m-qa.js rebuilds the box
      // with innerHTML on each tap; the observer puts the line back.
      var text = sentence(rows, list.getAttribute('data-rbm-w') || '');
      var labs = chips.querySelectorAll('.rbm-qsw__lab');
      var inseamLab = labs[labs.length - 1];
      var n = chips.querySelector('.rbf-note');
      if (!text || !inseamLab) { if (n) n.remove(); return; }
      if (!n) { n = document.createElement('p'); n.className = 'rbf-note rbf-note--sheet'; }
      if (n.nextElementSibling !== inseamLab) chips.insertBefore(n, inseamLab);
      if (n.textContent !== text) n.textContent = text;
    }
    paint();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(paint, 30); })
      .observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-rbm-w', 'class'] });
    return true;
  }

  // Both pickers are built by other modules after DOMContentLoaded; poll briefly.
  var tries = 0, gotPdp = false, gotSheet = false;
  (function wait() {
    if (!gotPdp) gotPdp = pdp();
    if (!gotSheet) gotSheet = sheet();
    if ((gotPdp && gotSheet) || ++tries > 40) return;
    setTimeout(wait, 150);
  })();
})();
